/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';

export default declareEntity({
    entity: "storeDetails",
    graphQL: "StoreDetail",
    name: "Store Detail",
    dynamoPrefix: 'sys',
    storageType: 'silo',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Store Detail ID",
            type: "id",
            id: true,
            defaultValue: (storeInfo) => {
                return storeInfo['id'];
            },
            required: true,
            primaryKey: true,
        },
        version: {
            name: "Definition version",
            type: "int",
            required: true,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            required: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['organisation_id'];
                }
            },
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        storeType: {
            name: "Store type",
            type: "string",
            defaultValue: "sql",
        },
        storeInfo: {
            name: "Store info",
            type: "object",
            defaultValue: {},
        },
        storeVersion: {
            name: "Store version",
            type: "int",
            defaultValue: 1,
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; }
});
